import { render, staticRenderFns } from "./UserResumeFolderController.vue?vue&type=template&id=65b2f5b7"
import script from "./UserResumeFolderController.vue?vue&type=script&lang=js"
export * from "./UserResumeFolderController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports